import React, { useEffect } from 'react';
import moment from 'moment/moment';
import { createQuoteApiCall, updateQuoteApiCall } from './Action';
import Modal from '../../common/model';
import { quotesSchema } from '../../schema/vendorSchema';
import { Grid, InputAdornment, IconButton, Tooltip, styled, Typography } from '@mui/material';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import {
  DeleteOutline as DeleteOutlineIcon,
  AddCircleOutline as AddCircleOutlineIcon,
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon
} from '@mui/icons-material';
import { FLEET_STATUS_REVERSE, translate } from '../../helper';
import TextField from '../../common/form/TextInput';
import MessageComposer from '../../common/message-composer';
import useUploadControllers from '../../common/hooks/useUploadControllers';
import { messageSchema } from '../../schema/vendorSchema';
import { DatePicker } from 'antd';
import en from 'antd/es/date-picker/locale/en_US';
import dayjs from 'dayjs';
import {
  DATE_TIME_FORMAT,
  DATE_TIME_FORMAT_SERVER,
  SERVER_DATE_FORMAT,
  UI_DATE_FORMAT,
  DISPLAY_ONLY_DATE_FORMAT,
  isAcceptedStatus
} from './helper';
import { calculateTotals } from '../../utils/CommonFunction';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import ThumbDefault from '../../assets/image/svg/Thumb_default.svg';
import { Select, MenuItem } from '@mui/material';

const IOSSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 'calc(var(--fs-xl)*2.2)',
  height: 'calc(var(--fs-xl)*1.3)',
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '200ms',
    '&.Mui-checked': {
      transform: 'translateX(var(--fs-lg))',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: '#111827',
        opacity: 1,
        border: 0
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5
      }
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#111827',
      border: '6px solid #fff'
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[600]
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: theme.palette.mode === 'light' ? 0.6 : 0.3
    }
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 'calc(var(--fs-xl)*1.1)',
    height: 'calc(var(--fs-xl)*1.1)'
  },
  '& .MuiSwitch-track': {
    borderRadius: 'calc(var(--sp-md2)*1.3)',
    backgroundColor: theme.palette.mode === 'light' ? '#9CA3AF' : '#39393D',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], { duration: 200 })
  }
}));

const SendQuoteWrapper = styled('div')(({ theme }) => ({
  '& .MuiTextField-root': {
    width: '100%'
  },
  '& .MuiInputBase-input': {
    padding: 'calc(var(--sp-xxs)*2) var(--sp-md2)'
  },
  '& .MuiInputBase-input.Mui-disabled': {
    color: '#000 !important',
    WebkitTextFillColor: '#000 !important'
  },
  '& .MuiOutlinedInput-root.Mui-disabled .MuiInputBase-input': {
    color: '#000 !important',
    WebkitTextFillColor: '#000 !important'
  },
  '& .MuiSelect-select.Mui-disabled': {
    color: '#000 !important',
    WebkitTextFillColor: '#000 !important'
  },
  '& .MuiOutlinedInput-root.Mui-disabled .MuiSelect-select': {
    color: '#000 !important',
    WebkitTextFillColor: '#000 !important'
  },
  '& .MuiOutlinedInput-root.Mui-disabled': {
    backgroundColor: '#F3F4F6 !important'
  },
  '.order-name-row': { marginBottom: 'calc(var(--sp-lg)*1.1)', height: 'calc(var(--fs-xl)*3)' },
  '.no-margin': { margin: 0 },
  '.actions-row': { display: 'flex', justifyContent: 'flex-end', paddingTop: 0 },
  '.info-row': { paddingTop: 'calc(var(--sp-md2)*3)' },
  '.info-required': {
    fontSize: 'var(--fs-lg)',
    fontWeight: 'normal',
    marginLeft: 'var(--sp-xxs)',
    position: 'relative',
    top: 'calc(var(--sp-xxs)*0.5)',
    pointerEvents: 'none'
  },
  '.composer-row': { marginBottom: 'var(--sp-lg)', marginTop: 'var(--sp-xxs)' },
  '.full-width-table': { width: '100%' },
  '.rounded-8 .MuiOutlinedInput-root': {
    borderRadius: 'calc(var(--sp-xxs)*2)',
    height: 'var(--fs-hero)'
  },
  '.rounded-40 .MuiOutlinedInput-root': {
    borderRadius: 'calc(var(--sp-xxs)*2)',
    height: 'var(--fs-hero)'
  },
  '.part-status-select': {
    borderRadius: 'calc(var(--sp-xxs)*2)',
    height: 'calc(var(--fs-hero)*1.157894)'
  },
  '.part-status-select .MuiSelect-select': {
    minHeight: 'unset !important',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    paddingTop: 0,
    paddingBottom: 0,
    fontSize: 'var(--fs-md)'
  },
  '.read-only-field': {
    height: 'var(--fs-hero)',
    border: '1px solid #ddd',
    width: '100%',
    backgroundColor: '#fff',
    borderRadius: 'calc(var(--sp-xxs)*2)'
  },
  '.read-only-field .MuiInputBase-input': { paddingLeft: 'calc(var(--sp-xxs)*3.2)' },
  '.no-pointer': { pointerEvents: 'none' },
  '.date-input': {
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    borderRadius: 'calc(var(--sp-xxs)*2)',
    padding: '0 var(--sp-md2)',
    height: 'calc(var(--fs-hero)*1.157894)',
    backgroundColor: '#fff',
    fontSize: 'var(--fs-md)',
    paddingLeft: 'calc(var(--sp-md)*2)',
    paddingRight: 'calc(var(--sp-md)*2)'
  },
  '.date-input .ant-picker-input': {
    height: '100%',
    alignItems: 'center'
  },
  '.date-input .ant-picker-input > input': {
    height: '100%'
  },
  '.icon-accept': { color: 'green', fontSize: 'calc(var(--fs-xs)*2.27)' },
  '.icon-reject': { color: 'red', fontSize: 'calc(var(--fs-xs)*2.27)' },
  '.description-error': {
    color: 'red',
    fontSize: 'var(--fs-sm)',
    marginTop: 'calc(var(--sp-xxs)*0.5)'
  },
  '.quote-cell': {
    color: '#111827',
    fontWeight: 400,
    lineHeight: '1.42',
    backgroundColor: '#fff',
    paddingTop: 'var(--sp-md2)',
    paddingBottom: 'var(--sp-md2)'
  },
  '.quote-cell-pad-left': { paddingLeft: 'calc(var(--sp-md2)*1.9)' },
  '.quote-cell-first': { borderRadius: 'calc(var(--sp-xxs)*2) 0 0 calc(var(--sp-xxs)*2)' },
  '.table-head-cell': {
    fontWeight: 500,
    fontSize: 'var(--fs-sm2)',
    color: '#6A6A89',
    padding: 'var(--sp-md2) 0 var(--sp-md2) calc(var(--sp-md2)*1.9)'
  }
}));
const Label = styled('label')(({ theme }) => ({
  fontSize: 'calc(var(--fs-xs)*1.6)',
  fontWeight: '500',
  marginBottom: 'var(--sp-xs)',
  color: '#000',
  lineHeight: 'normal',
  maxWidth: 'calc(var(--fs-hero)*6.75)',
  flex: '0 0 calc(var(--fs-hero)*6.75)'
}));

const LockedDatePicker = styled(DatePicker)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '& .ant-picker-input': {
    display: 'flex',
    justifyContent: 'center',
    width: '100%'
  },
  '& .ant-picker-input > input': {
    textAlign: 'center',
    fontSize: 'var(--fs-md) !important'
  },
  '& .ant-picker-input > input::placeholder': {
    fontSize: 'var(--fs-md) !important',
    lineHeight: 1
  },
  '& .ant-picker-suffix': {
    position: 'static',
    marginLeft: 'var(--sp-sm)',
    display: 'inline-flex',
    alignItems: 'center',
    color: '#000'
  },
  '& .ant-picker-suffix': {
    color: '#000'
  },
  '&.locked, &.ant-picker-disabled': {
    backgroundColor: '#F3F4F6 !important',
    borderColor: '#b7b9bdff !important'
  },
  '&.locked .ant-picker-input, &.ant-picker-disabled .ant-picker-input': {
    backgroundColor: '#F3F4F6 !important'
  },
  '&.locked .ant-picker-input > input, &.ant-picker-disabled .ant-picker-input > input': {
    color: '#000 !important',
    backgroundColor: '#F3F4F6 !important'
  },
  '&.locked .ant-picker-suffix, &.ant-picker-disabled .ant-picker-suffix': {
    opacity: 1,
    color: '#000'
  },
  '&.locked .ant-picker-clear, &.ant-picker-disabled .ant-picker-clear': {
    display: 'none'
  },
  '&:focus-within': {
    borderColor: '#1976d2 !important'
  }
}));

const QuotesModal = ({
  isOpen,
  orderDetail,
  refetch,
  user,
  onClickClose,
  vendorId,
  quoteItem,
  vendorData,
  isPartsMode = false
}) => {
  const firstQuoteStatus = orderDetail?.quotes?.[0]?.status || quoteItem?.status || '';
  const isAccepted = firstQuoteStatus === 'ACCEPTED';
  const isCustomerAndServiceAccepted =
    firstQuoteStatus === 'CUSTOMER ACCEPTED' || firstQuoteStatus === 'SERVICE ACCEPTED PENDING';
  const isBothAccepted = isAcceptedStatus(firstQuoteStatus);
  const is_tax_enabled = quoteItem?.is_tax_enabled || true;
  const [formValues, setFormValues] = React.useState({
    order_name: orderDetail?.name || '',
    order_fullfill_date: quoteItem?.order_fullfill_date
      ? dayjs(quoteItem.order_fullfill_date, DATE_TIME_FORMAT_SERVER)
      : null,
    description: quoteItem?.description || '',
    vendor: vendorId,
    invoice_number: quoteItem?.invoice_number || '',
    quote:
      quoteItem?.quote !== undefined && quoteItem?.quote !== null && quoteItem?.quote !== ''
        ? Number(quoteItem.quote)
        : '',
    is_tax_enabled,
    parts: []
  });
  const [errors, setErrors] = React.useState({});
  const [files, setFiles] = React.useState([]);
  const { uploadControllers, handleClose } = useUploadControllers(
    setFiles,
    onClickClose,
    isOpen,
    files
  );

  const runValidation = async (valuesToValidate = formValues) => {
    try {
      // 🔥 SKIP quote schema in parts mode
      if (isPartsMode) {
        const errObj = {};

        valuesToValidate.parts?.forEach((p, idx) => {
          // ❌ DO NOT initialize here
          if (!p.description) {
            if (!errObj.parts) errObj.parts = {};
            if (!errObj.parts[idx]) errObj.parts[idx] = {};

            errObj.parts[idx].description = 'Description is required';
          }
          if (!p.quantity || p.quantity <= 0) {
            if (!errObj.parts) errObj.parts = {};
            if (!errObj.parts[idx]) errObj.parts[idx] = {};

            errObj.parts[idx].quantity = 'Quantity is required';
          }

          // ✅ STATUS
          if (!p.fleet_status) {
            if (!errObj.parts) errObj.parts = {};
            if (!errObj.parts[idx]) errObj.parts[idx] = {};

            errObj.parts[idx].fleet_status = 'Status is required';

            if (!p.fulfill_date) {
              errObj.parts[idx].fulfill_date = 'Date is required';
            }

            return;
          }

          // ✅ DATE
          if (
            p.fleet_status === 'ON_ORDER' &&
            (!p.fulfill_date || !dayjs(p.fulfill_date).isValid())
          ) {
            if (!errObj.parts) errObj.parts = {};
            if (!errObj.parts[idx]) errObj.parts[idx] = {};

            errObj.parts[idx].fulfill_date = 'Date is required';
          }
        });
        setErrors(errObj);
        const hasErrors = errObj.parts
          ? Object.values(errObj.parts).some(
              (partErr) => partErr && Object.keys(partErr).length > 0
            )
          : false;

        return hasErrors ? errObj : null;
      }

      // 🧾 NORMAL FLOW (unchanged)
      await quotesSchema.validate(valuesToValidate, { abortEarly: false });
      setErrors({});
      return null;
    } catch (validationError) {
      const errObj = {};

      if (validationError?.inner?.length) {
        validationError.inner.forEach((e) => {
          if (!e.path) return;

          const path = e.path.replace(/\[(\d+)\]/g, '.$1');
          const keys = path.split('.');
          let cur = errObj;

          for (let i = 0; i < keys.length - 1; i++) {
            const k = keys[i];
            if (!(k in cur)) cur[k] = {};
            cur = cur[k];
          }

          cur[keys[keys.length - 1]] = e.message;
        });
      } else if (validationError.path) {
        errObj[validationError.path] = validationError.message;
      }

      setErrors(errObj);
      return errObj;
    }
  };
  const pathToKeys = (path) => path.match(/[^.[\]]+/g) || [];

  const deleteNestedKey = (obj, keys) => {
    const [first, ...rest] = keys;
    if (!(first in obj)) return obj;

    if (rest.length === 0) {
      const { [first]: _, ...restObj } = obj;
      return Object.keys(restObj).length ? restObj : undefined;
    }

    const child = deleteNestedKey(obj[first], rest);
    if (child === obj[first]) return obj;

    const next = { ...obj };
    if (child === undefined) {
      delete next[first];
    } else {
      next[first] = child;
    }
    return Object.keys(next).length ? next : undefined;
  };

  const clearError = (path) => {
    const keys = pathToKeys(path);
    setErrors((prev) => {
      if (!prev || Object.keys(prev).length === 0) return prev;
      const next = deleteNestedKey(prev, keys);
      return next || {};
    });
  };

  const handleComposerSubmit = async (values, attachment, actions) => {
    const merged = { ...formValues, description: values.text };
    const validationErr = await runValidation(merged);
    console.log('validationErr', validationErr);
    if (validationErr) {
      actions.setSubmitting(false);
      return;
    }
    const submitValues = { ...merged, attachment };
    handleSubmit(submitValues, actions);
  };

  const handleSubmit = (values, actions) => {
    delete values.order_name;
    const rawDate = values.order_fullfill_date;
    const isValidDate = rawDate && moment(rawDate, DATE_TIME_FORMAT, true).isValid();

    values.order_fullfill_date = isValidDate
      ? moment(rawDate, DATE_TIME_FORMAT).format(DATE_TIME_FORMAT_SERVER)
      : null;

    if (isPartsMode) {
      const mapFleetStatus = (status) => {
        switch (status) {
          case 'IN_STOCK':
            return 1;
          case 'ON_ORDER':
            return 2;
          case 'BACKORDERED':
            return 3;
          default:
            return null;
        }
      };
      const fixedParts = values.parts.map((part) => {
        let fulfillDateStr = part.fulfill_date
          ? dayjs(part.fulfill_date).format(UI_DATE_FORMAT)
          : null;

        const isValidDate = fulfillDateStr && dayjs(fulfillDateStr, UI_DATE_FORMAT, true).isValid();
        return {
          id: part.id,
          description: part.description,
          quantity: Number(part.quantity),

          fulfill_date: isValidDate
            ? dayjs(fulfillDateStr, UI_DATE_FORMAT).format(SERVER_DATE_FORMAT)
            : null,

          fleet_status: mapFleetStatus(part.fleet_status)
        };
      });

      const payload = {
        description: values.description,
        vendor: values.vendor,
        status: 'ACCEPTED',
        is_parts_order: true,
        order_id: orderDetail?.id,
        parts: fixedParts,
        attachment: values.attachment || []
      };

      if (quoteItem) {
        updateQuoteApiCall(quoteItem.id, payload, actions.setSubmitting, refetch, setFiles, isPartsMode);
      } else {
        createQuoteApiCall(payload, orderDetail, actions.setSubmitting, refetch, setFiles, isPartsMode);
      }

      return; // 🚨 STOP here (very important)
    }

    const fixedParts = values.parts.map((part) => {
      let fulfillDateStr = part.fulfill_date
        ? dayjs(part.fulfill_date).format(UI_DATE_FORMAT)
        : null;
      const isValidPartDate =
        fulfillDateStr && dayjs(fulfillDateStr, UI_DATE_FORMAT, true).isValid();
      const numVal = part.value === null || part.value === undefined ? NaN : Number(part.value);
      return {
        ...part,
        quantity: Number(part.quantity),
        fulfill_date: isValidPartDate
          ? dayjs(fulfillDateStr, UI_DATE_FORMAT).format(SERVER_DATE_FORMAT)
          : null,
        value: Number.isFinite(numVal) ? parseFloat(roundTo2(numVal).toFixed(2)) : 0
      };
    });
    const payload = {
      ...values,
      parts: fixedParts
    };
    if (
      isBothAccepted &&
      quoteItem?.quote !== undefined &&
      quoteItem?.quote !== null &&
      quoteItem?.quote !== ''
    ) {
      payload.quote = Number(quoteItem.quote);
    } else {
      const { total } = calculateTotals({
        parts: fixedParts,
        taxPercentage: isAcceptedStatus(firstQuoteStatus)
          ? quoteItem?.tax_percentage
          : vendorData?.tax_percentage,
        isTaxEnabled: values.is_tax_enabled
      });
      payload.quote = parseFloat(Number(total).toFixed(2));
    }
    if (quoteItem) {
      if (
        firstQuoteStatus === 'CUSTOMER ACCEPTED' ||
        firstQuoteStatus === 'SERVICE ACCEPTED PENDING'
      ) {
        payload.status = 'ACCEPTED';
      }
      updateQuoteApiCall(quoteItem.id, payload, actions.setSubmitting, refetch, setFiles);
    } else {
      payload.status = 'SENT';
      payload.order_id = orderDetail?.id;
      createQuoteApiCall(payload, orderDetail, actions.setSubmitting, refetch, setFiles);
    }
  };
  useEffect(() => {
    let initialData = [];
    if (isPartsMode) {
      // 🔥 PARTS MODE (clean, minimal)
      initialData =
        orderDetail?.parts?.map((part) => ({
          id: part.id,
          description: part.description,
          quantity: part.quantity,
          status: part.status,

          fleet_status: FLEET_STATUS_REVERSE[part.fleet_status] ?? '',

          fulfill_date: part.fulfill_date ? dayjs(part.fulfill_date, SERVER_DATE_FORMAT) : null
        })) || [];

      setFormValues({
        description: '',
        vendor: vendorId,
        parts: initialData,
        attachment: []
      });
    } else {
      initialData =
        orderDetail?.parts?.map((part) => ({
          ...part,
          description: part.description,
          quantity: part.quantity,
          ...(isPartsMode && {
            fleet_status: FLEET_STATUS_REVERSE[part.fleet_status] || ''
          }),
          fulfill_date: part.fulfill_date ? dayjs(part.fulfill_date, SERVER_DATE_FORMAT) : null,
          value:
            part.value === 0 || part.value === '0.00'
              ? null
              : part.value !== undefined && part.value !== null && part.value !== ''
              ? Number(part.value)
              : null
        })) || [];
      const restoredIsTaxEnabled =
        quoteItem && quoteItem.hasOwnProperty('is_tax_enabled')
          ? Boolean(quoteItem.is_tax_enabled)
          : true;
      setFormValues({
        order_name: orderDetail?.name || '',
        order_fullfill_date: quoteItem?.order_fullfill_date
          ? dayjs(quoteItem.order_fullfill_date, DATE_TIME_FORMAT_SERVER)
          : null,
        description: quoteItem?.description || '',
        vendor: vendorId,
        invoice_number: quoteItem?.invoice_number || '',
        quote:
          quoteItem?.quote !== undefined && quoteItem?.quote !== null && quoteItem?.quote !== ''
            ? Number(quoteItem.quote)
            : '',
        is_tax_enabled: restoredIsTaxEnabled,
        parts: initialData
      });
    }
    setErrors({});
  }, [orderDetail, quoteItem, vendorId, isPartsMode]);

  useEffect(() => {
    if (!quoteItem?.attachment || !quoteItem.attachment.length) return;
    setFiles((prev) => {
      const prevPaths = new Set((prev || []).map((f) => f.path));
      const toAdd = quoteItem.attachment
        .map((att) => {
          const path = att.path || null;
          if (!path) return null;
          const thumbnail = att.thumbnail || null;
          const fileUrl = att.file || null;
          const url = thumbnail || fileUrl || ThumbDefault;
          return {
            path,
            'content-type': att['content-type'] || '',
            file_name: att.file_name || '',
            fromServer: true,
            url
          };
        })
        .filter(Boolean)
        .filter((f) => !prevPaths.has(f.path));

      if (toAdd.length === 0) return prev || [];
      return [...(prev || []), ...toAdd];
    });
  }, [quoteItem]);

  function roundTo2(num) {
    return Math.round(num * 100) / 100;
  }
  const buddhistLocale = {
    ...en,
    lang: {
      ...en.lang,
      fieldDateFormat: UI_DATE_FORMAT,
      fieldDateTimeFormat: `${UI_DATE_FORMAT} HH:mm:ss`,
      yearFormat: 'YYYY',
      cellYearFormat: 'YYYY'
    }
  };
  const acceptedParts = (formValues.parts || []).filter((p) => p?.status === 2);
  const partsForTax = acceptedParts.length > 0 ? acceptedParts : formValues.parts || [];
  const {
    partsTotal: calcPartsTotal,
    totalTax: calcTotalTax,
    total: calcTotal
  } = calculateTotals({
    parts: partsForTax,
    taxPercentage: isAcceptedStatus(firstQuoteStatus)
      ? quoteItem?.tax_percentage
      : vendorData?.tax_percentage,
    isTaxEnabled: formValues.is_tax_enabled
  });
  useEffect(() => {
    if (
      isBothAccepted &&
      quoteItem?.quote !== undefined &&
      quoteItem?.quote !== null &&
      quoteItem?.quote !== ''
    )
      return;
    const newQuote = Number(calcTotal.toFixed(2));
    if (formValues.quote !== newQuote) {
      setFormValues((prev) => ({ ...prev, quote: newQuote }));
      clearError('quote');
    }
  }, [
    calcPartsTotal,
    calcTotalTax,
    calcTotal,
    formValues.is_tax_enabled,
    isBothAccepted,
    quoteItem
  ]);

  const initialPartsLength = orderDetail?.parts?.length || 0;

  const hasPartsChanged =
    isPartsMode &&
    formValues.parts.length !== initialPartsLength;

  return (
    <Modal
      title={isPartsMode ? 'Parts Ordered for Technician' : isBothAccepted ? 'invoice' : 'quote'}
      isOpen={isOpen}
      onClose={handleClose}
      width="calc(var(--fs-hero)*25.6)"
      padding="calc(var(--sp-sm)*2) calc(var(--sp-md2)*2.5)"
      weight={600}
      draggable>
      <SendQuoteWrapper>
        <div>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Label>{translate('orderName')}</Label>
            </Grid>
            <Grid className="order-name-row" item xs={12}>
              <TextField
                value={formValues.order_name}
                type="text"
                id="order_name"
                name="order_name"
                fullWidth
                disabled
                className="read-only-field"
                InputProps={{
                  sx: {
                    '& .MuiInputBase-input': {
                      fontSize: 'var(--fs-md2) !important',
                      fontWeight: 400
                    }
                  }
                }}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Label className="no-margin">{translate('itemDetails')}</Label>
              {!isPartsMode && (
                <FormControlLabel
                  control={
                    <IOSSwitch
                      checked={!!formValues.is_tax_enabled}
                      onChange={(e) => {
                        if (isBothAccepted) return;
                        const checked = e.target.checked;
                        setFormValues((prev) => ({ ...prev, is_tax_enabled: checked }));
                      }}
                      disabled={isBothAccepted}
                      inputProps={{ 'aria-label': 'Include tax toggle' }}
                    />
                  }
                  label={formValues.is_tax_enabled ? 'Include tax' : 'Exclude tax'}
                  labelPlacement="start"
                  sx={{
                    marginRight: 0,
                    gap: 'calc(var(--sp-sm)*2)',
                    '& .MuiFormControlLabel-label': {
                      fontWeight: 500,
                      fontSize: 'calc(var(--fs-xs)*1.6) !important',
                      color: '#6A6A89 !important'
                    }
                  }}
                />
              )}
            </Grid>
            <TableContainer
              component={Paper}
              elevation={0}
              sx={{
                boxShadow: 'none',
                borderRadius: 'calc(var(--sp-xxs)*0.5)',
                background: '#fff',
                marginTop: 'calc(var(--sp-sm)*2)',
                width: '100%'
              }}>
              <Table className="full-width-table" aria-label="simple table">
                <TableHead>
                  <TableRow sx={{ borderTop: '2px solid #E5E7EB' }}>
                    <TableCell className="table-head-cell" sx={{ width: '45%' }}>
                      {translate('descriptionPartNumber')}
                    </TableCell>
                    <TableCell className="table-head-cell" sx={{ width: '12%' }} align="right">
                      {translate('quantity')}
                    </TableCell>
                    <TableCell
                      className="table-head-cell"
                      sx={{ maxWidth: '30%', position: 'relative' }}
                      align="center">
                      {translate('itemFulfillDate')}
                    </TableCell>
                    <TableCell
                      className="table-head-cell"
                      sx={{ maxWidth: '10%', position: 'relative' }}
                      align="center">
                      {isPartsMode ? 'Status' : translate('itemPrice')}
                    </TableCell>
                    <TableCell
                      sx={{ width: 'calc(var(--fs-hero)*1.2)' }}
                      align="center"></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {formValues.parts.map((part, idx) => (
                    <React.Fragment key={idx}>
                      <TableRow sx={{ background: '#fff', position: 'relative' }}>
                        <TableCell
                          className="quote-cell quote-cell-first quote-cell-pad-left"
                          sx={{
                            fontSize: 'var(--fs-sm2)',
                            width: '45%',
                            minWidth: 'calc(var(--fs-hero)*6.5)'
                          }}>
                          <TextField
                            value={part.description ?? ''}
                            type="text"
                            fullWidth
                            multiline
                            minRows={1}
                            placeholder={translate('descriptionPartNumber')}
                            className="rounded-8"
                            disabled={isBothAccepted && (!isPartsMode || part.status === 2)}
                            onChange={({ target }) => {
                              if (isBothAccepted && (!isPartsMode || part.status === 2)) return;
                              setFormValues((prev) => {
                                const newParts = [...(prev.parts || [])];
                                newParts[idx] = {
                                  ...(newParts[idx] || {}),
                                  description: target.value
                                };
                                return { ...prev, parts: newParts };
                              });
                              clearError(`parts[${idx}].description`);
                            }}
                            InputProps={{
                              sx: {
                                backgroundColor: isBothAccepted && (!isPartsMode || part.status === 2)
                                  ? '#F3F4F6 !important'
                                  : '#fff !important',
                                '& .MuiOutlinedInput-notchedOutline': {
                                  borderColor: errors.parts?.[idx]?.description ? 'red' : '#D1D5DB'
                                },
                                '& .MuiInputBase-input': {
                                  fontSize: 'var(--fs-md) !important',
                                  backgroundColor: isBothAccepted && (!isPartsMode || part.status === 2) ? '#F3F4F6' : '#fff',
                                  textAlign: 'left',
                                  fontWeight: '400',
                                  paddingRight: 'calc(var(--sp-md2)*1.5)',
                                  color: '#000 !important'
                                }
                              }
                            }}
                          />
                        </TableCell>
                        <TableCell
                          align="right"
                          className="quote-cell quote-cell-pad-left"
                          sx={{
                            fontSize: 'var(--fs-md)',
                            minWidth: 'calc(var(--fs-hero)*1.5)',
                            width: '12%'
                          }}>
                          <TextField
                            value={part.quantity ?? ''}
                            type="number"
                            fullWidth
                            placeholder={translate('quantity')}
                            className="rounded-40"
                            disabled={isBothAccepted && (!isPartsMode || part.status === 2)}
                            onChange={({ target }) => {
                              if (isBothAccepted && (!isPartsMode || part.status === 2)) return;
                              setFormValues((prev) => {
                                const newParts = [...(prev.parts || [])];
                                const num = target.value === '' ? '' : target.valueAsNumber;
                                newParts[idx] = {
                                  ...(newParts[idx] || {}),
                                  quantity: Number.isNaN(num) ? '' : num
                                };
                                return { ...prev, parts: newParts };
                              });
                              clearError(`parts[${idx}].quantity`);
                            }}
                            InputProps={{
                              sx: {
                                backgroundColor: isBothAccepted && (!isPartsMode || part.status === 2)
                                  ? '#F3F4F6 !important'
                                  : '#fff !important',
                                '& .MuiOutlinedInput-notchedOutline': {
                                  borderColor: errors.parts?.[idx]?.quantity ? 'red' : '#D1D5DB'
                                },
                                '& .MuiInputBase-input': {
                                  fontSize: 'var(--fs-md) !important',
                                  textAlign: 'right',
                                  fontWeight: '400',
                                  paddingRight: 'calc(var(--sp-md2)*1.5)',
                                  // height: '40px',
                                  color: '#000 !important'
                                }
                                // height: '40px'
                              }
                            }}
                            inputProps={{ step: '1', min: 0 }}
                          />
                        </TableCell>
                        <TableCell
                          align="center"
                          className="quote-cell quote-date-cell"
                          sx={{
                            minWidth: 'calc(var(--fs-hero)*3)',
                            maxWidth: 'calc(var(--fs-hero)*4.5)',
                            width: 'calc(var(--fs-hero)*4.25)'
                          }}>
                          <LockedDatePicker
                            className={`${(isBothAccepted && (!isPartsMode || part.status === 2)) ? 'locked' : ''} date-input`}
                            popupClassName="responsive-datepicker-dropdown"
                            style={{
                              border: errors.parts?.[idx]?.fulfill_date
                                ? '1.5px solid red'
                                : '1px solid #D1D5DB'
                            }}
                            allowClear={false}
                            placeholder={translate('itemFulfillDate')}
                            locale={buddhistLocale}
                            format={(value) =>
                              value ? dayjs(value).format(DISPLAY_ONLY_DATE_FORMAT) : ''
                            }
                            disabledDate={(current) => {
                              if (!isPartsMode) {
                                return current && current < dayjs().startOf('day');
                              }

                              const status = part.fleet_status;

                              if (status === 'IN_STOCK') {
                                return true; // disable all
                              }

                              if (status === 'ON_ORDER') {
                                return current && current < dayjs().startOf('day'); // future only
                              }

                              if (status === 'BACKORDERED') {
                                return true; // allow past dates
                              }

                              return current && current < dayjs().startOf('day');
                            }}
                            disabled={
                              (isBothAccepted && (!isPartsMode || part.status === 2)) || (isPartsMode && part.fleet_status === 'IN_STOCK') || (isPartsMode && part.fleet_status === 'BACKORDERED')
                            }
                            onChange={(value) => {
                              if (isBothAccepted && !isPartsMode) return;
                              setFormValues((prev) => {
                                const newParts = [...(prev.parts || [])];
                                newParts[idx] = {
                                  ...(newParts[idx] || {}),
                                  fulfill_date: value || null
                                };
                                return { ...prev, parts: newParts };
                              });
                              clearError(`parts[${idx}].fulfill_date`);
                            }}
                            value={
                              part.fulfill_date
                                ? dayjs.isDayjs(part.fulfill_date)
                                  ? part.fulfill_date
                                  : dayjs(part.fulfill_date, UI_DATE_FORMAT)
                                : undefined
                            }
                          />
                        </TableCell>
                        <TableCell
                          align="center"
                          className="quote-cell"
                          sx={{ minWidth: 'var(--fs-hero)', maxWidth: 'var(--fs-hero)' }}>
                          {isPartsMode ? (
                            <Select
                              displayEmpty
                              className="part-status-select"
                              placeholder="Order Status"
                              disabled={isBothAccepted && (!isPartsMode || part.status === 2)}
                              error={!!errors.parts?.[idx]?.fleet_status}
                              sx={{
                                '& .MuiOutlinedInput-notchedOutline': {
                                  borderColor: errors.parts?.[idx]?.fleet_status ? 'red' : '#D1D5DB'
                                },
                                '& .MuiSelect-icon': {
                                  width: 'calc(var(--sp-lg)*1.13)',
                                  height: 'calc(var(--sp-lg)*1.13)',
                                  top: '50%',
                                  transform: 'translateY(-50%)',
                                  right: 'calc(var(--sp-xxs)*2)'
                                },
                                '& .MuiInputBase-input': {
                                  paddingRight: 'calc(var(--sp-lg)*2)',
                                  lineHeight: 'calc(var(--sp-lg)*1.6)'
                                },
                                '& .MuiSelect-select': {
                                  fontSize: 'var(--fs-md2)',
                                  lineHeight: 'calc(var(--sp-lg)*1.6)',
                                  paddingTop: 'calc(var(--sp-xxs)*2)',
                                  paddingBottom: 'calc(var(--sp-xxs)*2)'
                                }
                              }}
                              fullWidth
                              value={part.fleet_status || ''}
                              renderValue={(selected) => {
                                if (!selected) {
                                  return <span style={{ color: '#9CA3AF' }}>Order Status</span>;
                                }

                                // 🔥 ensure string
                                const value =
                                  typeof selected === 'number'
                                    ? FLEET_STATUS_REVERSE[selected]
                                    : selected;

                                if (!value) {
                                  return <span style={{ color: '#9CA3AF' }}>Order Status</span>;
                                }

                                return value
                                  .replace('_', ' ')
                                  .toLowerCase()
                                  .replace(/\b\w/g, (c) => c.toUpperCase());
                              }}
                              onChange={(e) => {
                                const value = e.target.value;

                                setFormValues((prev) => {
                                  const newParts = [...(prev.parts || [])];
                                  newParts[idx] = {
                                    ...newParts[idx],
                                    fleet_status: value,
                                    fulfill_date:
                                      value === 'IN_STOCK' ? null : newParts[idx].fulfill_date
                                  };
                                  return { ...prev, parts: newParts };
                                });

                                clearError(`parts[${idx}].fleet_status`);
                                clearError(`parts[${idx}].fulfill_date`);

                                // 🔥 trigger revalidation
                              }}>
                              <MenuItem value="IN_STOCK" sx={{ fontSize: 'var(--fs-md2)' }}>
                                In Stock
                              </MenuItem>
                              <MenuItem value="ON_ORDER" sx={{ fontSize: 'var(--fs-md2)' }}>
                                On Order
                              </MenuItem>
                              <MenuItem value="BACKORDERED" sx={{ fontSize: 'var(--fs-md2)' }}>
                                Backordered
                              </MenuItem>
                            </Select>
                          ) : (
                            <TextField
                              value={part.value ?? ''}
                              type="number"
                              fullWidth
                              placeholder={translate('itemPrice')}
                              className="rounded-40"
                              disabled={isBothAccepted}
                              onChange={({ target }) => {
                                if (isBothAccepted) return;
                                setFormValues((prev) => {
                                  const newParts = [...(prev.parts || [])];
                                  const num = Number.isNaN(target.valueAsNumber)
                                    ? null
                                    : target.valueAsNumber;
                                  newParts[idx] = { ...(newParts[idx] || {}), value: num };
                                  return { ...prev, parts: newParts };
                                });
                                clearError(`parts[${idx}].value`);
                              }}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start" sx={{ ml: '50px', mr: 0 }}>
                                    <Typography
                                      sx={{ fontSize: 'var(--fs-md2) !important', lineHeight: 1 }}>
                                      $
                                    </Typography>
                                  </InputAdornment>
                                ),
                                sx: {
                                  backgroundColor: isBothAccepted
                                    ? '#F3F4F6 !important'
                                    : '#fff !important',
                                  '& .MuiOutlinedInput-notchedOutline': {
                                    borderColor: errors.parts?.[idx]?.value ? 'red' : '#D1D5DB'
                                  },
                                  '& .MuiInputBase-input': {
                                    fontSize: 'var(--fs-md) !important',
                                    textAlign: 'left',
                                    fontWeight: '400',
                                    paddingRight: 'calc(var(--sp-md2)*1.5)',
                                    color: '#000'
                                  }
                                }
                              }}
                              inputProps={{ className: 'quote-price-input', step: '0.01', min: 0 }}
                            />
                          )}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{
                            width: 'calc(var(--fs-hero)*1.2)',
                            paddingY: 'var(--sp-md2)',
                            paddingRight: 'calc(var(--sp-sm)*2)',
                            verticalAlign: 'middle'
                          }}>
                          {(!isBothAccepted || (isPartsMode && part.status !== 2)) ? (
                            <IconButton
                              aria-label="delete-row"
                              size="small"
                              sx={{
                                backgroundColor: 'transparent',
                                '&:hover': { backgroundColor: 'transparent' },
                                margin: '0 auto'
                              }}
                              disableRipple
                              disableFocusRipple
                              disabled={(formValues.parts || []).length < 2}
                              onClick={() => {
                                if ((formValues.parts || []).length < 2) return;
                                setFormValues((prev) => ({
                                  ...prev,
                                  parts: (prev.parts || []).filter((_, i) => i !== idx)
                                }));
                              }}>
                              <DeleteOutlineIcon
                                htmlColor={
                                  (formValues.parts || []).length < 2 ? '#adb1b6' : '#EF4444'
                                }
                                sx={{ fontSize: 'calc(var(--fs-xs)*2.27)' }}
                              />
                            </IconButton>
                          ) : part.status === 2 ? (
                            <IconButton
                              size="small"
                              sx={{
                                backgroundColor: 'transparent',
                                '&:hover': { backgroundColor: 'transparent' },
                                margin: '0 auto'
                              }}
                              disableRipple
                              disableFocusRipple
                              tabIndex={-1}
                              className="no-pointer">
                              <CheckCircleIcon
                                className="icon-accept"
                                sx={{ fontSize: 'calc(var(--fs-xs)*2.27)' }}
                              />
                            </IconButton>
                          ) : part.status === 3 ? (
                            <IconButton
                              size="small"
                              sx={{
                                backgroundColor: 'transparent',
                                '&:hover': { backgroundColor: 'transparent' },
                                margin: '0 auto'
                              }}
                              disableRipple
                              disableFocusRipple
                              tabIndex={-1}
                              className="no-pointer">
                              <CancelIcon
                                className="icon-reject"
                                sx={{ fontSize: 'calc(var(--fs-xs)*2.27)' }}
                              />
                            </IconButton>
                          ) : null}
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            {(!isBothAccepted || isPartsMode) && (
              <Grid item xs={12} className="actions-row">
                <Tooltip title={translate('addItem')} placement="bottom" arrow>
                  <IconButton
                    aria-label="add-item"
                    sx={{
                      backgroundColor: 'transparent',
                      marginRight: 'calc(var(--sp-sm)*2)',
                      '&:hover': { backgroundColor: 'transparent' }
                    }}
                    disableRipple
                    disableFocusRipple
                    onClick={() => {
                      setFormValues((prev) => ({
                        ...prev,
                        parts: [
                          ...(prev.parts || []),
                          {
                            description: '',
                            quantity: '',
                            fulfill_date: null,
                            value: null,
                            status: 1
                          }
                        ]
                      }));
                    }}>
                    <AddCircleOutlineIcon
                      color="primary"
                      sx={{ fontSize: 'calc(var(--fs-xs)*2.27)' }}
                    />
                  </IconButton>
                </Tooltip>
              </Grid>
            )}
            {!isPartsMode && (
              <>
                <Grid item xs={12}>
                  <Label>{translate(isBothAccepted ? 'invoiceDetails' : 'quoteDetails')}</Label>
                </Grid>
                <Grid item xs={12}>
                  <TableContainer
                    component={Paper}
                    elevation={0}
                    sx={{
                      boxShadow: 'none',
                      borderRadius: 2,
                      background: '#fff',
                      marginTop: 'calc(var(--sp-sm)*2)',
                      width: '100%'
                    }}>
                    <Table className="full-width-table" aria-label="summary table">
                      <TableHead>
                        <TableRow sx={{ borderTop: '2px solid #E5E7EB' }}>
                          <TableCell className="table-head-cell" sx={{ width: '40%' }}>
                            {translate(isBothAccepted ? 'invoiceNumber' : 'quoteNumber')}
                          </TableCell>
                          <TableCell className="table-head-cell" sx={{ width: '20%' }} align="left">
                            Total Tax
                          </TableCell>
                          <TableCell className="table-head-cell" sx={{ width: '40%' }} align="left">
                            {translate(isBothAccepted ? 'invoiceTotal' : 'quoteTotal')}
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{ background: '#fff' }}>
                          <TableCell
                            sx={{
                              paddingY: 'var(--sp-md2)',
                              paddingLeft: 'calc(var(--sp-md2)*1.9)'
                            }}>
                            <TextField
                              value={formValues.invoice_number}
                              type="text"
                              fullWidth
                              disabled={isAccepted}
                              placeholder={translate(
                                isBothAccepted ? 'invoiceNumber' : 'quoteNumber'
                              )}
                              className="rounded-40"
                              onChange={({ target }) => {
                                setFormValues((prev) => ({
                                  ...prev,
                                  invoice_number: target.value
                                }));
                                clearError('invoice_number');
                              }}
                              InputProps={{
                                sx: {
                                  backgroundColor: '#fff !important',
                                  '& .MuiOutlinedInput-notchedOutline': {
                                    borderColor: errors.invoice_number ? 'red' : '#D1D5DB'
                                  },
                                  '& .MuiInputBase-input': {
                                    fontSize: 'var(--fs-md) !important',
                                    textAlign: 'left',
                                    fontWeight: '400',
                                    paddingRight: 'calc(var(--sp-md2)*1.5)',
                                    height: 'var(--fs-hero)',
                                    color: '#000'
                                  },
                                  height: 'var(--fs-hero)'
                                }
                              }}
                            />
                          </TableCell>
                          <TableCell
                            sx={{
                              paddingY: 'var(--sp-md2)',
                              paddingLeft: 'calc(var(--sp-md2)*1.9)'
                            }}>
                            <TextField
                              value={
                                Number.isFinite(calcTotalTax) ? Number(calcTotalTax.toFixed(2)) : ''
                              }
                              type="number"
                              fullWidth
                              disabled
                              placeholder={'Total Tax'}
                              className="rounded-40"
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment sx={{ ml: '20px', mr: 0 }} position="start">
                                    <Typography
                                      sx={{ fontSize: 'var(--fs-md2) !important', lineHeight: 1 }}>
                                      $
                                    </Typography>
                                  </InputAdornment>
                                ),
                                sx: {
                                  backgroundColor: isBothAccepted
                                    ? '#F3F4F6 !important'
                                    : '#fff !important',
                                  '& .MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#D1D5DB',
                                    color: '#000 !important'
                                  },
                                  '& .MuiInputBase-input': {
                                    fontSize: 'var(--fs-md) !important',
                                    textAlign: 'left',
                                    fontWeight: '400',
                                    paddingRight: 'calc(var(--sp-md2)*1.5)',
                                    color: '#000 !important'
                                  }
                                }
                              }}
                              inputProps={{ step: '0.01', min: 0 }}
                            />
                          </TableCell>
                          <TableCell
                            sx={{
                              paddingY: 'var(--sp-md2)',
                              paddingLeft: 'calc(var(--sp-md2)*1.9)'
                            }}>
                            <TextField
                              value={Number.isFinite(calcTotal) ? Number(calcTotal.toFixed(2)) : ''}
                              type="number"
                              fullWidth
                              placeholder={translate(
                                isBothAccepted ? 'invoiceTotal' : 'quoteTotal'
                              )}
                              className="rounded-40"
                              disabled
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment sx={{ ml: '20px', mr: 0 }} position="start">
                                    <Typography
                                      sx={{ fontSize: 'var(--fs-md2) !important', lineHeight: 1 }}>
                                      $
                                    </Typography>
                                  </InputAdornment>
                                ),
                                sx: {
                                  backgroundColor: isBothAccepted
                                    ? '#F3F4F6 !important'
                                    : '#fff !important',
                                  '& .MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#D1D5DB',
                                    color: '#000 !important'
                                  },
                                  '& .MuiInputBase-input': {
                                    fontSize: 'var(--fs-md) !important',
                                    textAlign: 'left',
                                    fontWeight: '400',
                                    paddingRight: 'calc(var(--sp-md2)*1.5)',
                                    color: '#000 !important'
                                  }
                                }
                              }}
                              inputProps={{ step: '0.01', min: 0 }}
                            />
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Grid>
              </>
            )}
            <Grid item xs={12} className="info-row">
              <Label>
                {isPartsMode
                  ? 'Order Information'
                  : translate(isBothAccepted ? 'invoiceInformation' : 'quoteInformation')}
              </Label>
            </Grid>
            <Grid className="composer-row" item xs={12}>
              <MessageComposer
                placeholder={
                  isPartsMode
                    ? 'Enter order information'
                    : translate(
                        isBothAccepted ? 'enterInvoiceInformation' : 'enterQuoteInformation'
                      )
                }
                onSubmit={handleComposerSubmit}
                inputMinHeight={'calc(var(--fs-hero)*3.75)'}
                inputMaxHeight={'calc(var(--fs-hero)*8)'}
                validationSchema={messageSchema}
                uploadIdValue={orderDetail?.id}
                files={files}
                setFiles={setFiles}
                uploadControllers={uploadControllers}
                unlimited
                isMobile
                prevValue={formValues.description}
                allowEmptySubmit
                btnText={
                  isPartsMode
                    ? 'Send Parts'
                    : isCustomerAndServiceAccepted
                    ? translate('finalizePaymentSendInvoice')
                    : isAccepted
                    ? translate('viewInvoice')
                    : translate('sendQuote')
                }
                composerDisabled={isAccepted && !hasPartsChanged}
              />
            </Grid>
          </Grid>
        </div>
      </SendQuoteWrapper>
    </Modal>
  );
};

export default QuotesModal;
